export default "__VITE_ASSET__VXkwuFAX__"